import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Flex,
  FormLabel,
  Input,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Portal,
  Spinner,
} from "@chakra-ui/react";
import { WidgetProps } from "@rjsf/utils";

import { useEnumOrInput } from "../hooks/use-enum-or-input";

export const EnumOrInput = (props: WidgetProps & { isLoading?: boolean }) => {
  const { onChange, value, readonly, label, enumDisabled, isLoading } = props;

  const {
    options,
    isSearching,
    isOpen,
    onClose,
    wrapperRef,
    inputRef,
    id,
    startSearching,
    onSearchValueChanged,
  } = useEnumOrInput(props);

  return (
    <Box>
      <FormLabel>{label}</FormLabel>
      <Flex w="full" ref={wrapperRef} position="relative">
        <Input
          w="full"
          id={id}
          ref={inputRef}
          type="text"
          value={value}
          onClick={readonly ? undefined : startSearching}
          onChange={(e) => onSearchValueChanged(e.target.value)}
          isReadOnly={readonly}
        />

        {!readonly && (
          <ChevronDownIcon
            zIndex={1}
            position="absolute"
            top="50%"
            transform="translateY(-50%)"
            right={2}
          />
        )}

        <Menu onClose={onClose} isOpen={isOpen} isLazy>
          <MenuButton
            top="100%"
            opacity={0}
            pointerEvents="none"
            w={0}
            h={0}
            position="absolute"
            left={0}
            type="button"
          />

          {isSearching && (
            <Portal>
              <MenuList minW={wrapperRef.current?.offsetWidth ?? 0}>
                <MenuOptionGroup onChange={onChange} value={value}>
                  {options.length ? (
                    options.map(({ value, label }) => (
                      <MenuItemOption
                        value={value}
                        isDisabled={enumDisabled?.includes(value)}
                        key={value + label + ""}
                        _hover={{ bg: "gray.100" }}
                        _disabled={{
                          bg: "rgba(226,232,240, 0.3)",
                        }}
                      >
                        {label}
                      </MenuItemOption>
                    ))
                  ) : (
                    <MenuItemOption display="flex" justifyContent="center">
                      {isLoading ? <Spinner boxSize={4} /> : "No options"}
                    </MenuItemOption>
                  )}
                </MenuOptionGroup>
              </MenuList>
            </Portal>
          )}
        </Menu>
      </Flex>
    </Box>
  );
};
